import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanyLogo = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo Icon */}
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shadow-card">
          <Icon name="Zap" size={32} color="white" strokeWidth={2.5} />
        </div>
      </div>
      
      {/* Company Name */}
      <h1 className="text-3xl font-heading font-semibold text-text-primary mb-2">
        Everforce Manager
      </h1>
      
      {/* Subtitle */}
      <p className="text-text-secondary text-sm">
        Sistema de Gestión Empresarial
      </p>
      
      {/* Divider */}
      <div className="mt-6 mb-8">
        <div className="w-12 h-0.5 bg-primary mx-auto rounded-full"></div>
      </div>
    </div>
  );
};

export default CompanyLogo;